import React from "react";
import { useForm } from "react-hook-form";
import { updateDb } from "../services/updateDb";

import { useNavigate } from "react-router-dom";

import ProjectForm from "./ProjectForm";
import { useAppContext } from "../AppContext";
import { useTranslation } from "react-i18next";

const AddProjectPage = () => {
  const { t } = useTranslation();
  const { triggerHeaderRefresh } = useAppContext();
  const navigate = useNavigate();
  const { register, handleSubmit } = useForm();

  const onSubmit = async (data) => {
    let projObj = {
      name: data.name,
      orgId: data.orgId,
      ownerUserId: data.ownerUserId,
    };

    const res = await updateDb("/api/projects/", projObj);

    if (res.success) {
      triggerHeaderRefresh();
      navigate("/projects", { state: { message: t('domain') + " " + t('added'), type: "success" } });
    }
  };

  return (
    <div id="content">
      <div id="content-title">{t('add_domain')}</div>

      <div className="content-bubble">
        <ProjectForm
          register={register}
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          text={t('add_domain')}
        />
      </div>
    </div>
  );
};

export default AddProjectPage;
